import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const AIRTIME_URL = "https://airtime.bhasglobalcarenetwork.com";

let cached: { airtime_url: string; airtime_live: boolean } | null = null;

export function useAirtimeLink() {
  const [link, setLink] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api.get("/public/links").then((r) => { cached = r.data; setLink(r.data); }).catch(() => setLink({ airtime_url: AIRTIME_URL, airtime_live: false }));
  }, []);
  return link?.airtime_live ? link.airtime_url : null;
}
